import './App.css';
import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// import Login from './components/Auths/Login';
// import Patient from './components/Patient';
// import Documents from './components/Documents';
// import Notes from './components/Notes';
// import Scheduler from './components/Schedular';
// import PrivateRouts from './routes/PrivateRouts';
// import { DEFAULT_LOCAL_PATH } from './constents';
// import Profile from './components/Patient/Profile';
import { ToastContainer } from 'react-toastify';
import Loader from './Loader';
import 'react-toastify/dist/ReactToastify.css';
// import PriorAuth from './components/PriorAuth';
// import Communication from './components/Communication';
// import Intake from './components/Patient/Intake';
// import NotFound from './NotFound';
// import Report from './components/Report/Index';
// import Layout from './components/Layouts/Layout';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <div className="App">
      <Loader />
      <AppRoutes />
      {/* <Router>
        <Routes>
          <Route element={<PrivateRouts />}>
            <Route
              path={`${DEFAULT_LOCAL_PATH}/scheduler`}
              element={<Layout />}
            >
              <Route index element={<Scheduler />} />
            </Route>
            <Route path={`${DEFAULT_LOCAL_PATH}/patient`} element={<Layout />}>
              <Route index element={<Patient />} />
              <Route path=":page" element={<Profile />} />
              <Route path=":page/:patientId" element={<Profile />} />
              <Route path=":page/:patientId/:appId" element={<Profile />} />
              <Route path=":page/:patientId/:appId" element={<Profile />} />
              <Route
                path=":page/:patientId/:appId/:visitId"
                element={<Profile />}
              />
              <Route
                path=":page/:patientId/:appId/:visitId/:treatmentId"
                element={<Profile />}
              />
              <Route path="intake" element={<Intake />} />
            </Route>
            <Route
              path={`${DEFAULT_LOCAL_PATH}/documents`}
              element={<Layout />}
            >
              <Route index element={<Documents />} />
            </Route>
            <Route path={`${DEFAULT_LOCAL_PATH}/notes`} element={<Layout />}>
              <Route index element={<Notes />} />
              <Route path=":page" element={<Notes />} />
              <Route path=":page/:type" element={<Notes />} />
            </Route>
            <Route
              path={`${DEFAULT_LOCAL_PATH}/priorAuth`}
              element={<Layout />}
            >
              <Route index element={<PriorAuth />} />
            </Route>
            <Route path={`${DEFAULT_LOCAL_PATH}/report`} element={<Layout />}>
              <Route index element={<Report />} />
              <Route path="credentialing" element={<Report />} />
            </Route>
            <Route
              path={`${DEFAULT_LOCAL_PATH}/communication`}
              element={<Layout />}
            >
              <Route index element={<Communication />} />
            </Route>
          </Route>
          <Route path={`${DEFAULT_LOCAL_PATH}`} element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router> */}
      <ToastContainer />
    </div>
  );
}

export default App;
